var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagnifyGlassCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4 7.807a5.9 5.9 0 11-11.8 0 5.9 5.9 0 0111.8 0zm-1.192 5.839a7.5 7.5 0 111.131-1.131l2.69 2.69a1.8 1.8 0 012.244.243l3.586 3.586a1.8 1.8 0 010 2.546l-.586.586a1.8 1.8 0 01-2.546 0l-3.585-3.586a1.8 1.8 0 01-.244-2.244l-2.69-2.69zm4.934 2.934a.2.2 0 00-.283 0l-.586.586a.2.2 0 000 .282l3.586 3.586a.2.2 0 00.282 0l.586-.585a.2.2 0 000-.283l-3.585-3.586zM11 6.439a.8.8 0 10-1.131-1.132l-3.87 3.869-.868-.869A.8.8 0 104 9.438l1.293 1.293a1 1 0 001.414 0L11 6.44z",
    fill: "#232D54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyGlassCheck);
export default __webpack_public_path__ + "static/media/magnify_glass_check.bdc64f6ba00e4c16d0ca7d9c9094a40b.svg";
export { ForwardRef as ReactComponent };